import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { Dialog } from './dialog.jsx';

/**
 * Retry prompt for a screen whose initial data load failed. Renders a modal
 * over the screen's inline error state with [Cancel] [Try again]. Cancel
 * dismisses the prompt (the inline error remains visible); Try again re-runs
 * the screen's load and closes the prompt.
 * @param {Object} props
 * @param {string | null} props.error
 * @param {() => void} props.onRetry
 * @returns {JSX.Element | null}
 */
export function ErrorRetryDialog({ error, onRetry }) {
	const { t } = useTranslation();
	const [dismissed, setDismissed] = useState(false);

	useEffect(() => {
		if (error) { setDismissed(false); }
	}, [error]);

	if (!error || dismissed) { return null; }

	return (
		<Dialog
			title={t('dialog.loadFailedTitle')}
			message={t('dialog.loadFailedMessage')}
			confirmLabel={t('btn.tryAgain')}
			cancelLabel={t('btn.cancel')}
			onConfirm={() => { setDismissed(true); onRetry(); }}
			onCancel={() => setDismissed(true)}
		/>
	);
}
